import { useInView } from '@/hooks/useInView';

const modes = [
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/tarelka.svg', label: 'UFO' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/kazhan.svg', label: 'Bat' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/pingvino.svg', label: 'Penguin' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/auto.svg', label: 'Car' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/mlun.svg', label: 'Windmill' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/litak.svg', label: 'Plane' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/bezop.svg', label: 'Security system' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/inshi.svg', label: 'And other...' },
];

export default function RobotPossibilities() {
  const { ref, inView } = useInView();

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-14">
        <div className={`flex-1 transition-all duration-700 ${inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-500 mb-3">Versatility</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 font-syne mb-4">
            A robot with thousands of possibilities
          </h2>
          <p className="text-gray-500 mb-8 text-sm">The standard set includes 12 sensors that turn the robot into 30 different devices:</p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {modes.map((mode, i) => (
              <div
                key={mode.label}
                className={`flex flex-col items-center gap-2 bg-gray-50 rounded-xl p-4 hover:bg-yellow-50 hover:border-yellow-200 border border-transparent transition-all duration-300 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <img src={mode.img} alt={mode.label} className="w-full h-full object-contain" />
                </div>
                <span className="text-xs font-semibold text-gray-700 text-center">{mode.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={`flex-shrink-0 transition-all duration-700 delay-200 ${inView ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}>
          <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-yellow-400">
            <img
              src="https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/%D0%A0%D0%B5%D0%B6%D0%B8%D0%BC%D1%8B_2.jpg"
              alt="Robot modes"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
